import { FC, useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import DataTable from 'react-data-table-component'
import {
  encrypt,
  fetchData,
  formatDatePublic,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import { KTIcon } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import { Modal } from 'react-bootstrap'
import Loader from '../components/Loader'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/UseAuthStore'
import { Tr } from '../../../_metronic/i18n/Tr'

const ViewHelpAndSupport: FC = () => {
  let t = Tr()
  const { menuIdEdit, menuId } = useMenuIdPermissions()

  const [offset, setOffset] = useState(0)
  const [limit, setLimit] = useState(5)
  const [supportList, setSupportList] = useState([])
  const [totalRecords, setTotalRecords] = useState('') as any
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [adminList, setAdminList] = useState([])
  const [rowAdminSelections, setRowAdminSelections] = useState<{ [key: number]: string }>({})
  const [showAssignColumn, setShowAssignColumn] = useState(true)
  const [adminId, setAdminId] = useState('')
  const [isSuperAdmin, setIsSuperAdmin] = useState('')
  const navigate = useNavigate()
  const { setSupportCount } = useAuthStore()
  const adminData = JSON.parse(sessionStorage.getItem('admin') || '{}')

  const [statusList] = useState([
    { label: 'All', value: '' },
    { label: 'Progress', value: '0' },
    { label: 'Resolve', value: '1' },
    { label: 'Rejected', value: '2' },
  ])

  const [recordList] = useState([
    { label: 'All', value: '' },
    { label: 'USER', value: 'USER' },
    { label: 'VENDOR', value: 'VENDOR' }, 
  ])
  const [status, setStatus] = useState('')
  const [selectedRecordType, setSelectedRecordType] = useState('')
  const [description, setDescription] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [dataLoaded, setIsDataLoaded] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const handleCloseInfo = () => setShowInfo(false)
  const handleShowInfo = () => setShowInfo(true)

  //  support list api call
  const supportListApiCall = async (limit1?: any, offset1?: any) => {
    if (!dataLoaded) {
      setIsLoading(true)
    }

    const param: any = {
      limit: limit1,
      offset: offset1,
      status,
      search: searchTerm,
      adminId: isSuperAdmin == '0' ? '' : adminId,
      recordType: selectedRecordType == '' ? '' : selectedRecordType,
    }

    const res = await fetchData('admin/viewsupport', param)

    if (res.status == '200') {
      const data = res.data

      setSupportList(data.data)
      setTotalRecords(data.totalRecords)
      setIsDataLoaded(true)
    } else {
      toasterrormsg(res.message)
    }

    setIsLoading(false)
  }

  const adminListApiCall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/adminList', param)

    if (response.status == '200') {
      let data = response.data
      let opt: any = []
      data.map((items: any, index: any) => {
        if (items.adminId != 1) {
          opt.push({ value: items.adminId, label: items.fullName })
        }
      })

      setAdminList(opt)
    } else {
      toasterrormsg(response.message)
    }
  }
  const changeHelpAndSupportUnreadCount = async () => {
    var param: any = {
      adminId: adminData.mainadminId == '0' ? '0' : adminData.adminId,
    }
    var response: any = await fetchData('admin/readsupport', param)

    if (response.status == '200') {
      setSupportCount(true)
    } else {
      toasterrormsg(response.message)
    }
  }

  const assignAdminToSupport = async (helpandsupportId: number, adminId: string) => {
    if (!adminId) return toasterrormsg('Please select an admin before applying.')

    const param = {
      helpandsupportId: helpandsupportId,
      adminId: adminId,
    }
    const response = await fetchData('admin/assignSupportAdmin', param)

    if (response.status == 200) {
      supportListApiCall(limit, offset) // Refresh list
      toastsuccessmsg(response.message)
      setRowAdminSelections({})
    } else {
      toasterrormsg(response.message)
    }
  }

  // function to change the status of the  help and support
  const rejectconfirmation = async (status: any, helpandsupportId: any, adminId: any) => {
    let swalOptions: any

    if (status == '2') {
      swalOptions = {
        title: 'Are You Sure? You Want to Reject This Support.',
        icon: 'warning',
        showCancelButton: true,
        input: 'text',
        inputLabel: 'Reason',
        inputPlaceholder: 'Enter Reject Reason',
        inputValidator: (value: any) => {
          if (!value) {
            return 'Reject Reason Required!'
          }
        },
      }
    } else if (status == '1') {
      swalOptions = {
        title: 'Are You Sure? You Want to Approve This Support.',
        icon: 'warning',
        showCancelButton: true,
      }
    }

    Swal.fire(swalOptions).then(async (result) => {
      if (result.isConfirmed) {
        const inputValue = result.value

        if (
          status == '1' ||
          (status == '2' && inputValue !== undefined && inputValue.trim() !== '')
        ) {
          var dataObj: any = {
            helpandsupportId: helpandsupportId,
            status: status,
          }
          if (adminId != '0' && adminId != '' && adminId != undefined) {
            dataObj.adminId = adminId
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/supportstatuschange', dataObj)

          if (res.status == 200) {
            Swal.fire({
              title: 'Status Change Successfully!',
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                setStatus('')
                supportListApiCall(limit, offset)
              }
            })
          } else {
            toasterrormsg(res.message)
          }
        } else {
          Swal.fire({
            title: 'Invalid Input!',
            text: 'Please enter a valid reason.',
            icon: 'error',
          })
        }
      }
    })
  }

  const handlePageChange = (newPage: number) => {
    const newOffset = (newPage - 1) * limit
    setOffset(newOffset)
    supportListApiCall(limit, newOffset)
  }

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setLimit(newRowsPerPage)
    supportListApiCall(newRowsPerPage, offset)
  }
  // search Data
  const searchData = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.fnserch(e, 1)
      // inputRef.current.focus();
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='d-flex justify-content-between flex-wrap w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={`${t("Search Help & Support")}`}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex flex-wrap gap-2'>
          <Select
            name='status'
            id='status'
            placeholder='Select'
            isSearchable={true}
            isClearable={true}
            options={statusList}
            value={statusList.find((option: any) => option.value == status) || ''}
            onChange={(e: any) => {
              setStatus(e ? e.value : '')
            }}
          />
          <Select
            name='recortType'
            id='recortType'
            placeholder='Select Sender Role'
            isSearchable={true}
            isClearable={true}
            options={recordList}
            value={recordList.find((option: any) => option.value == selectedRecordType) || ''}
            onChange={(e: any) => {
              setSelectedRecordType(e ? e.value : '')
            }}
          />
        </div>
      </div>
    )
  }

  const redirectToChat = (data: any) => {
    navigate(
      getEncryptedRoute('../chat', {
        menuId: menuId,
        id: data.helpandsupportId,
        userId: data.recordId,
      })
    )

  }

  // Define your DataTable columns
  const column = useMemo(() => {
    const baseColumns: any[] = [
      {
        name: t('No'),
        cell: (row: any, index: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{index + 1}</div>
          </div>
        ),
        selector: (row: any, index: any) => index + 1,
        width: '50px',
      },
      {
        name: t('Ticket Id'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.supportCode != '' ? '#' + row.supportCode : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.supportCode),
        filter: true,
        width: '200px',
      },
      {
        name: t('Ticket Status'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.status == 0 ? (
              <span className='badge badge-warning mx-2'>{t("In Progress")}</span>
            ) : row.status == 1 ? (
              <span className='badge badge-success mx-2'>{t("Resolved")}</span>
            ) : row.status == 2 ? (
              <span className='badge badge-light-danger mx-2'>{t("Rejected")}</span>
            ) : (
              <div className='fw-bold fs-5'>-</div>
            )}
          </div>
        ),
        width: '200px',
      },
      {
        name: t('Sender Role'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.recordType != '' ? row.recordType : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.created),
        filter: true,
        width: '230px',
      },
      {
        name: t('Sender Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.fullName != '' ? row.fullName : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.fullName),
        filter: true,
        width: '200px',
      },

      {
        name: t('Email/Contact'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.email != '' ? row.email : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.email),
        filter: true,
        width: '250px',
      },
      {
        name: t('Subject'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.subject != '' ? row.subject : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.subject),
        filter: true,
        width: '250px',
      },

      {
        name: t('Message'),
        cell: (row: any) => (
          <button
            className='btn btn-sm text-primary fw-bold text-hover-primary text-start p-0'
            onClick={() => {
              setDescription(row.description)
              handleShowInfo()
            }}
          >
            <div className='fw-bold fs-5 text-truncate w-250px'>
              {row.description != '' ? row.description : '-'}
            </div>
          </button>
        ),
        sortable: true,
        selector: (row: any) => String(row.description),
        filter: true,
        width: '250px',
      },
      {
        name: t('Date Submitted'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.created != '' ? formatDatePublic(row.created) : '-'}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.created),
        filter: true,
        width: '230px',
      },

      {
        name: t('Action'),
        cell: (row: any) => {
          return (
            <div className='d-flex w-100 align-items-center'>
              {row.status == 0 && menuIdEdit && (
                <button
                  className='btn btn-sm btn-icon btn-color-success btn-active-light-success'
                  title='Resolve Support'
                  onClick={() => {
                    rejectconfirmation('1', row.helpandsupportId, row.adminId)
                  }}
                >
                  <KTIcon iconName='check-square' className='fs-1' />
                </button>
              )}
              {menuIdEdit ? (
                <button
                  className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary ms-auto'
                  title='Chat With Customer'
                  onClick={() => {
                    redirectToChat(row)
                  }}
                >
                  <div className='position-relative'>
                    <KTIcon iconName='messages' className='fs-1 p-0 text-primary' />
                    <div
                      style={{
                        fontSize: '0.7rem',
                        padding: '3px 5px',
                        minWidth: '15px',
                        height: '15px',
                        top: '-5px',
                        right: '-5px',
                      }}
                      className='d-flex align-items-center justify-content-center text-white bg-purple rounded-circle  position-absolute  pt-1'
                    >
                      {row.unreadCount && row.unreadCount <= 9
                        ? row.unreadCount
                        : row.unreadCount > 9
                          ? '9+'
                          : row.unreadCount == '' ||
                            row.unreadCount == undefined ||
                            row.unreadCount == null
                            ? '0'
                            : '0'}
                    </div>
                  </div>
                </button>
              ) : (
                ''
              )}
            </div>
          )
        },
        width: '100px',
      },
    ]

    // Conditionally add Assign Admin column
    if (showAssignColumn) {
      baseColumns.push(
        {
          name: t('Assign'),
          cell: (row: any) => (
            <div className='d-flex align-items-center gap-2' style={{ minWidth: 280 }}>
              <div style={{ flex: 1 }}>
                <Select
                  options={adminList}
                  placeholder={t('Select Admin')}
                  className='w-100'
                  isDisabled={row.status == 1 ? true : false}
                  value={adminList.find(
                    (opt: any) =>
                      opt.value ==
                      (row.adminId != '0' || row.adminId != ''
                        ? row.adminId
                        : rowAdminSelections[row.helpandsupportId])
                  )}
                  onChange={(selectedOption: any) => {
                    if (row.status == 1) {
                      toasterrormsg('Report Is Already Resolved')
                    } else {
                      setRowAdminSelections({
                        ...rowAdminSelections,
                        [row.helpandsupportId]: selectedOption?.value,
                      })
                    }
                  }}
                  menuPortalTarget={document.body} // ✅ important
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ high z-index
                    menu: (base) => ({ ...base, zIndex: 9999 }), // optional extra
                  }}
                />
              </div>
              {rowAdminSelections[row.helpandsupportId] && (
                <button
                  className='btn btn-sm btn-primary'
                  style={{ whiteSpace: 'nowrap' }}
                  onClick={() =>
                    assignAdminToSupport(
                      row.helpandsupportId,
                      rowAdminSelections[row.helpandsupportId]
                    )
                  }
                >
                  {t("Assign")}
                </button>
              )}
            </div>
          ),
          width: '320px',
        },
        {
          name: t('Resolved Duration'),
          cell: (row: any) => (
            <div className='my-3'>
              <div className='fw-bold fs-5'>{row.duration != '' ? row.duration : '-'}</div>
            </div>
          ),
          width: '320px',
        }
      )
    }

    return baseColumns
  }, [rowAdminSelections, adminList, showAssignColumn, isSuperAdmin, t])

  useEffect(() => {

    const getProfile = async () => {
      var param: any = {
        adminId: adminData.adminId,
      }
      var response: any = await fetchData('admin/viewProfile', param)

      if (response.status == '200') {
        var data = response.data[0]
        let isSuperAdmin = data.mainadminId
        setAdminId(data.adminId)
        setIsSuperAdmin(isSuperAdmin)
        isSuperAdmin == 0 ? setShowAssignColumn(true) : setShowAssignColumn(false)
      } else {
        toasterrormsg(response.message)
      }
    }
    getProfile()
  }, [])

  useEffect(() => {
    if (isSuperAdmin !== '') {
      supportListApiCall(limit, offset)
    }
  }, [isSuperAdmin, limit, offset, status, searchTerm, selectedRecordType])

  useEffect(() => {
    adminListApiCall()
    changeHelpAndSupportUnreadCount()
  }, [])

  // useEffect(() => {
  //   setTimeout(() => {

  //     changeHelpAndSupportUnreadCount()
  //   }, 1000);
  // }, [])

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t("View Help & Support")}</PageTitle>

      {
        <div className='card card-flush py-4'>
          <div className='card-body pt-0'>
            <DataTable
              columns={column}
              data={supportList}
              pagination
              paginationServer={true}
              subHeader={true}
              subHeaderComponent={
                <CustomHeader search={searchTerm} isfoc={focus} fnserch={searchData} />
              }
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              paginationTotalRows={totalRecords}
              paginationPerPage={limit}
              paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                paginationComponentOptions={{
          rowsPerPageText: t('Rows Per Page'),
        }}
            />
          </div>
        </div>
      }
      <Modal show={showInfo} onHide={handleCloseInfo} backdrop='static' keyboard={false}>
        <div
          className='modal fade show'
          id='kt_modal_upload'
          tabIndex={-1}
          style={{ display: 'block' }}
          aria-modal='true'
          role='dialog'
        >
          {/* <!--begin::Modal dialog--> */}
          <div className='modal-dialog modal-dialog-centered mw-700px'>
            {/* <!--begin::Modal content--> */}
            <div className='modal-content'>
              {/* <!--begin::Form--> */}
              <div className='form' id='kt_modal_upload_form'>
                {/* <!--begin::Modal header--> */}
                <div className='modal-header d-flex justify-content-between border-bottom border-1 border-success'>
                  {/* <!--begin::Modal title--> */}
                  <h2 className='fw-bold'>Description</h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    onClick={handleCloseInfo}
                  >
                    <i className='ki-duotone ki-cross fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className='modal-body pt-10 pb-15 px-lg-17'>
                  <div className='row text-break'>
                    {description && <div>{description}</div>}
                    {!description && (
                      <label className='form-label text-muted text-center'>
                        No Description Found
                      </label>
                    )}
                  </div>
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewHelpAndSupport }
